import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close--modal",
  "use": "icon-close--modal-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-close--modal\"><circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#B7D5B9\" /><path d=\"M26.477 11.893a1.152 1.152 0 0 1 1.63 1.628l-6.921 6.92 6.925 6.926a1.152 1.152 0 0 1-1.629 1.629l-6.925-6.926-6.924 6.926a1.152 1.152 0 0 1-1.63-1.63l6.926-6.924-6.921-6.921a1.152 1.152 0 0 1 1.629-1.628l6.92 6.92 6.92-6.92Z\" fill=\"#006442\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol